























import { Component, Mixins } from "vue-property-decorator";
import { AccountViewerMixin } from "./mixins";

@Component
export default class AccountViewer extends Mixins(AccountViewerMixin) {
}
